import React from "react";
import SharedPasswordExpiredContent from "../components/password_expired_content";

export default function PasswordExpiredContent({ actionKey }: { actionKey: string }) {
  return (
    <SharedPasswordExpiredContent
      actionKey={actionKey}
      title="Reset Password Link Has Expired"
      description={
        <>
          For security purposes, password reset links expire after an hour from when it was sent.
          <br />
          <br />
          If you still need to reset your password, please request a new link and it will be sent to
          the email associated with your account.
        </>
      }
      requestAnotherLinkEndpointUrl="/password_reset/request_another_link"
      onLinkRequestSuccessRedirectUrl="/password_link_reset"
    />
  );
}
